import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

export const API = `${backendUrl.replace(/\/$/, "")}/api`;

// A autenticação vive exclusivamente no cookie HttpOnly emitido pelo backend.
// Não guardamos o token em JavaScript (localStorage/sessionStorage): assim, um
// eventual XSS não consegue exfiltrar a sessão.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// O token de acesso dura 1 hora. Quando expira, pedimos um novo com o cookie de
// renovação e repetimos o pedido — é isto que mantém a sessão iniciada sem que
// ninguém volte a escrever a password. Se a renovação falhar, a sessão acabou.
let refreshing = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.includes("/auth/login") || original?.url?.includes("/auth/refresh");
    if (error.response?.status !== 401 || original?._retried || isAuthCall) {
      return Promise.reject(error);
    }
    original._retried = true;
    try {
      // Vários pedidos a falhar ao mesmo tempo partilham a mesma renovação.
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(original);
    } catch {
      return Promise.reject(error);
    }
  },
);

export function apiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
